export const UNREGISTER = '/tag/unregister';
export const UNREGISTER_VEHICLE = tagNumber => `/tag/unregister/tag-number/${tagNumber}`;
export const UNREGISTER_VEHICLE_SUMMARY = '/tag/unregister/summary';